import
{
	useState,
	useRef,
	useReducer,
	useEffect,
	FormEvent
}
	from "react"
import
{
	useDispatch,
	useSelector
}
	from "react-redux"
import {FontAwesomeIcon}
	from "@fortawesome/react-fontawesome"
import {solid}
	from "@fortawesome/fontawesome-svg-core/import.macro"
import Multiselect
	from "multiselect-react-dropdown"
import {Popover}
	from "react-tiny-popover"
import
{
	Tab,
	Tabs
}
	from "react-bootstrap"
import LeDatePicker
	from "../../components/leDatePicker"
import {SelectReact}
	from "../../components/select"
import _
	from "lodash"
import {sprintf}
	from "sprintf-js"

import
{
	RootState,

	enableIdleLockSwitch,
	disableIdleLockSwitch
}
	from "./../../globals"
import
{
	buttonClickHandling,
	formatField,
	isEmpty,
	imageTypes,
	monthRef,
	toAscendingDate,
	UIState,
	validateField,
	getErrorMessage,
	getAccessPermissions
}
	from "./../../common"
import Constants, {ROLE, tunning}
	from "./../../constants"
import CustomIcon
	from "./../../components/customIcon"
import {DataDisplayModal}
	from "./../../components/sectionContainer"
import UnderlineHeading
	from "./../../components/underlineHeading"
import PhoneField, {formatPhoneDisplay}
	from "./../../components/phoneField"
import {cursoCorto, cursosDeAlumno, pildoraDeCurso, sinAcentos}
	from "./../../utils/cursoCorto"
import {horarioBonito}
	from "./../../utils/horarioBonito"
import StudentsService
	from "./../../services/campus/students.service"
import AuthService
	from "./../../services/auth.service"
import EnrollmentsService
	from "./../../services/campus/enrollments.service"
import AdvisorsPicker
	from "./../../components/enrollment/advisorsPicker"
import {AdvisorSelection, AvailableScheduleDTO}
	from "./../../models/EnrollmentHistoryDTO"
import {ordenarHorarios}
	from "./enrollStudentModal"
import {formatLocalDateTime}
	from "./../../components/enrollment/format"
import {useAvatarPorDefecto}
	from "./../../utils/avatarPorDefecto"
import StudentHistoryTab
	from "./studentHistoryTab"
import StudentDocumentsTab
	from "./studentDocumentsTab"
import {useEsTelefono}
	from "./../../utils/esTelefono"
import {montoBonito}
	from "./../../utils/monto"
import StudentNotes
	from "./studentNotes"
import StudentAuditLogTab
	from "./studentAuditLogTab"
import HttpManager
	from "./../../services/HttpManager"

import "./../../components/dropdown/style.css"
import "./../../components/input/style.css"
import "./studentProfile.css"
import { ahoraCdmx } from "../../utils/horaMexico"

type  State               = {isButtonDisabled : boolean}
const initialState : State = {isButtonDisabled : true}

type Action=
{
	type    : "setIsButtonDisabled",
	payload : boolean
}

const reducer = (state : State, action : Action) : State=>
{
	switch (action.type){case "setIsButtonDisabled" : return{...state, isButtonDisabled : action.payload}}
}

const StudentInfoModal = (props : any)=>
{
	const {selectedStudent, allowedUpdate, academicDegrees, closeFn, afterCloseFn, date} = props
	const esTelefono : boolean = useEsTelefono(1024)

	let   fileReader : any
	const [state, trigger] = useReducer(reducer, initialState)
	const dispatch = useDispatch()
	const idleLocked        : boolean = useSelector((state : RootState) => state.idleLockSwitch.value)
	const avatarPorDefecto  : string  = useAvatarPorDefecto()
	const sessionToken      : string | null = useSelector((state : RootState) => state.sessionToken.value)
	const themeToggle       : boolean = useSelector((state : RootState) => state.themeToggle.value)
	const userProfile : any = useSelector((state: RootState) => state.userProfile.value)
	//Agregar observaciones tiene permiso propio: Admisiones las escribe sin poder editar la ficha (Esteban, 2026-09-24).
	const puedeObservar : boolean = !!getAccessPermissions(userProfile, "studentNotes").create
	const basicInfo         : any = useSelector((state : RootState) => state.basicInfo.value)
	const currentUserCampus : any = useSelector((state : RootState) => state.currentUserCampus.value)
	const campusRef         : any = useSelector((state : RootState) => state.campusRef.value)
	const [editableStudent, setEditableStudent] = useState<any>(null)
	const [unfilledMainData, setUnfilledMainData] = useState<boolean>(false)
	const [wrongValueOnFields, setWrongValueOnFields] = useState<boolean>(false)
	const [noCityProvided, setNoCityProvided] = useState<boolean>(false)
	const [noDigitProvided, setNoDigitProvided] = useState<boolean>(false)
	const [noContactsProvided, setNoContactsProvided] = useState<boolean>(false)
	const [wrongContactsProvided, setWrongContactsProvided] = useState<boolean>(false)
	const [unfilledFields, setUnfilledFields] = useState<boolean>(false)
	const [unchangedRecord, setUnchangedRecord] = useState<boolean>(false)
	const [moduleReady, setModuleReady] = useState<boolean>(false)
	const [noTagsProvided, setNoTagsProvided] = useState<boolean>(false)
	// Cursos del alumno: se derivan de sus matrículas, no los escribe nadie.
	const cursosAlumno : string[] = (selectedStudent && selectedStudent.cursos)
		? selectedStudent.cursos
		: cursosDeAlumno([].concat(selectedStudent?.enrollments || [], selectedStudent?.nonActiveEnrollments || []))
	const [saveSuccess, setSaveSuccess] = useState<boolean>(false)
	const [saveError, setSaveError] = useState<any>(null)
	const [minDate, setMinDate] = useState<any>(null)
	const [maxDate, setMaxDate] = useState<any>(null)
	const [warningDate, setWarningDate] = useState<any>(null)
	const [currentTab, setCurrentTab] = useState<string | null>("profile")
	//Documentos del alta: se pueden subir varios. Para un menor, la identificación del
	//padre o tutor es obligatoria; la del alumno es opcional (Esteban, 2026-09-11).
	const [documentosNuevos, setDocumentosNuevos] = useState<{tipo : number, archivo : File}[]>([])
	const [tipoDocumento, setTipoDocumento] = useState<number>(1)
	//Matrícula obligatoria al crear: un alumno nuevo no se guarda sin horario.
	const [horarios, setHorarios] = useState<AvailableScheduleDTO[] | null>(null)
	/*
		Varios horarios, no uno. La gente se inscribe en mas de un curso a la vez y
		antes habia que dar de alta al alumno y matricularlo otra vez a mano.
		(Esteban, 2026-09-21)
	*/
	const [horariosElegidos, setHorariosElegidos] = useState<AvailableScheduleDTO[]>([])
	//Hay que confirmar la lista antes de guardar: son matriculas con cobro detras.
	const [matriculasConfirmadas, setMatriculasConfirmadas] = useState<boolean>(false)

	const alternarHorario = (horario : AvailableScheduleDTO) =>
	{
		setMatriculasConfirmadas(false)
		setHorariosElegidos
		(
			horariosElegidos.some((elegido) => elegido.id === horario.id)
				? horariosElegidos.filter((elegido) => elegido.id !== horario.id)
				: [...horariosElegidos, horario]
		)
	}
	const [busquedaHorario, setBusquedaHorario] = useState<string>("")
	const [asesoras, setAsesoras] = useState<AdvisorSelection[] | null>(null)
	const [notaMatricula, setNotaMatricula] = useState<string>("")
	const [reinicioEnviado, setReinicioEnviado] = useState<boolean>(false)
	const http = HttpManager.getInstance()
	const [UIStatus, setUIStatus] = useState<number>(UIState.NORMAL)
	let   recordFormRef          : any = useRef<HTMLFormElement>(null)
	let   contactFormRef         : any = useRef<HTMLFormElement>(null)
	let   correlativoClase365Ref : any = useRef<HTMLInputElement>(null)
	let   firstNameRef           : any = useRef<HTMLInputElement>(null)
	let   lastNameRef            : any = useRef<HTMLInputElement>(null)
	let   zipcodeRef             : any = useRef<HTMLInputElement>(null)
	let   imageRef               : any = useRef<HTMLInputElement>(null)
	let   observationsRef        : any = useRef<HTMLTextAreaElement>(null)
	let   countrySelRef          : any = useRef<HTMLSelectElement>(null)
	let   stateSelRef            : any = useRef<HTMLSelectElement>(null)
	let   stateNameRef           : any = useRef<HTMLInputElement>(null)
	let   cityNameRef            : any = useRef<HTMLInputElement>(null)
	let   nationalitySelRef      : any = useRef<HTMLSelectElement>(null)
	let   addressRef             : any = useRef<HTMLInputElement>(null)
	let   emailRef               : any = useRef<HTMLInputElement>(null)
	let   identificationCodeRef  : any = useRef<HTMLInputElement>(null)
	let   passwordRef            : any = useRef<HTMLInputElement>(null)
	let   lastSchoolNameRef      : any = useRef<HTMLInputElement>(null)
	let   currentOccupationRef   : any = useRef<HTMLInputElement>(null)
	let   tabDivRef              : any = useRef<HTMLDivElement>(null)
	let   tagDivRef              : any = useRef<HTMLDivElement>(null)
	const minYear                : any = +date.split("-")[0] - 154
	const linkInfo               : any=
	{
		facebook  : "Facebook",
		instagram : "Instagram",
		tiktok    : "TikTok"
	}

	const yearsToAlmostPresent : any = [...Array(150)].map((_, i) => (minYear) + i)

	const editableIsMinor = () : boolean=>
	{
		const raw : string = (editableStudent && (editableStudent.birthdayValue || editableStudent.birthday) || "") + ""
		const match = raw.match(/(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})/) || raw.match(/(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})/)
		if(!match) return false
		const year  = +(match[1].length == 4 ? match[1] : match[3])
		const month = +match[2]
		const day   = +(match[1].length == 4 ? match[3] : match[1])
		const birth = new Date(year, month - 1, day)
		const today = ahoraCdmx()
		let age = today.getFullYear() - birth.getFullYear()
		if(today.getMonth() < birth.getMonth() || (today.getMonth() == birth.getMonth() && today.getDate() < birth.getDate())) age--
		return age < 18
	}

	//Le manda al alumno el enlace para que él mismo ponga su contraseña.
	const reiniciarContrasena = async ()=>
	{
		try
		{
			await AuthService.requestPasswordReset(editableStudent.email)
			setReinicioEnviado(true)
		}
		catch(error)
		{
			setSaveError(getErrorMessage(error))
			setUIStatus(UIState.ERROR)
		}
	}

	//Horarios disponibles para matricular al alumno nuevo en el mismo momento del alta.
	const horariosVisibles : any[] = (()=>
	{
		if(horarios == null)
		{
			return []
		}

		const ordenados : any[] = ordenarHorarios(horarios)
		const terminos  : string[] = sinAcentos(busquedaHorario).split(/\s+/).filter((t : string) => t != "")

		if(terminos.length < 1)
		{
			return ordenados
		}

		return ordenados.filter
		(
			(horario : any)=>
			{
				const texto : string = sinAcentos
				(
					[
						horario.courseName, horario.levelName, horario.name, horario.code,
						horario.periodName, horario.sessions, horario.mentorName,
						formatLocalDateTime(horario.startDate)
					].filter(Boolean).join(" ")
				)

				return terminos.every((t : string) => texto.includes(t))
			}
		)
	})()

	useEffect
	(
		()=>
		{
			if(editableStudent == null || editableStudent.id != null || horarios != null)
			{
				return
			}

			http.scheduleService.getAvailableSchedules(campusRef[currentUserCampus].id)
				.then((response : any) => setHorarios(response.data))
				.catch(() => setHorarios([]))
		},
		[editableStudent]
	)

	const unedit = ()=>
	{
		if(editableStudent && editableStudent.id == null)
		{
			closeFn()
		}

		setEditableStudent(null)
	}

	const editStudent = ()=>
	{
		setEditableStudent
		({
			...selectedStudent, nationality_id : selectedStudent.nationality_id || campusRef[currentUserCampus].company.country_id,
			country_id  : selectedStudent.country_id || campusRef[currentUserCampus].company.country_id,
			/*
				"??" y no "||": el grado academico 0 es "Ninguno", un valor de verdad,
				y con "||" se convertia en "" -- el select salia en blanco y al guardar
				se mandaba vacio, que Laravel vuelve null y la columna (NOT NULL) rechaza.
				Resultado: 4.772 alumnos de produccion (uno de cada cinco) no se podian
				editar en absoluto; ni una observacion, ni un telefono. Solo se veia
				"Error en la base de datos.". (2026-09-21)
			*/
			academic_degree_id : selectedStudent.academic_degree_id ?? "",
			identification_type_id : selectedStudent.identification_type_id || basicInfo.countryRef["C_" + campusRef[currentUserCampus].company.country_id].preferred_identification_type_id
		})
	}

	const saveRecord = ()=>
	{
		if(recordFormRef && recordFormRef.current)
		{
			if(!recordFormRef.current.checkValidity())
			{
				if(!unfilledFields)
				{
					setUnfilledFields(true)

					if(currentTab == "profile")
					{
						recordFormRef.current.reportValidity()
					}
					else
					{
						tabDivRef?.current?.focus()
						setUnfilledMainData(true)
					}

					setTimeout
					(
						() =>
						{
							setUnfilledFields(false)
							setUnfilledMainData(false)
						},
						3000
					)
				}
			}
			else
			{
				{
					if
					(
						(
							basicInfo.countryRef["C_" + editableStudent.country_id].states.length > 0 &&
							basicInfo.countryRef["C_" + editableStudent.country_id].stateRef["S_" + editableStudent.state_id].cities.length > 0
						)
							&&
						(editableStudent.city == null || editableStudent.city.id == null)
					)
					{
						if(!unfilledFields)
						{
							setUnfilledFields(true)

							if(currentTab == "profile")
							{
								setNoCityProvided(true)
							}
							else
							{
								tabDivRef?.current?.focus()
								setUnfilledMainData(true)
							}

							setTimeout
							(
								()=>
								{
									setUnfilledFields(false)
									setNoCityProvided(false)
								},
								3000
							)
						}
					}
					else
					{
						//Un contacto de emergencia solo es obligatorio cuando el alumno es menor (Esteban, 2026-09-11).
						if(editableIsMinor() && editableStudent.contacts.length < 1)
						{
							if(!unfilledFields)
							{
								if(currentTab == "profile")
								{
									tabDivRef?.current?.focus()
								}

								setUnfilledFields(true)
								setNoContactsProvided(true)

								setTimeout
								(
									()=>
									{
										setUnfilledFields(false)
										setNoContactsProvided(false)
									},
									3000
								)
							}
						}
						else
						{
							if(contactFormRef && contactFormRef.current)
							{
								if(!contactFormRef.current.checkValidity())
								{
									if(!unfilledFields)
									{
										setUnfilledFields(true)
										setWrongValueOnFields(true)

										if(currentTab == "profile")
										{
											tabDivRef?.current?.focus()
											setWrongContactsProvided(true)
										}
										else
										{
											contactFormRef.current.reportValidity()
										}

										setTimeout
										(
											()=>
											{
												setUnfilledFields(false)
												setWrongValueOnFields(false)
												setWrongContactsProvided(false)
											},
											3000
										)
									}
								}
								else
								{
									if(saveError != null)
									{
										setSaveError(null)
									}

									if(editableStudent.id == null)
									{
										//Menor de edad: obligatoria la del padre o tutor y opcional la del alumno.
										//Mayor de edad: obligatoria la suya (Esteban, 2026-09-11).
										if(editableIsMinor())
										{
											if(!documentosNuevos.some((documento : any) => documento.tipo == 2))
											{
												setSaveError(Constants.Common.newStudentTutorIdRequired)
												setUIStatus(UIState.ERROR)
												return
											}
										}
										else
										{
											if(!documentosNuevos.some((documento : any) => documento.tipo == 1))
											{
												setSaveError(Constants.Common.newStudentIdMissing)
												setUIStatus(UIState.ERROR)
												return
											}
										}

										if(horariosElegidos.length < 1)
										{
											setSaveError(Constants.Common.newStudentScheduleRequired)
											setUIStatus(UIState.ERROR)
											return
										}

										if(!matriculasConfirmadas)
										{
											setSaveError("Revise las matrículas elegidas y marque la casilla de confirmación")
											setUIStatus(UIState.ERROR)
											return
										}

										if(asesoras === null)
										{
											setSaveError(Constants.Common.advisorsRequired)
											setUIStatus(UIState.ERROR)
											return
										}

										if(notaMatricula.trim() === "")
										{
											setSaveError(Constants.Common.signupNoteRequired)
											setUIStatus(UIState.ERROR)
											return
										}
									}

									setUIStatus(UIState.LOCKED)
									dispatch(enableIdleLockSwitch())

									//Lo que la asesora escribe al dar de alta entra como la PRIMERA observación de la
									//bitácora, firmada por ella y con su hora, en vez de quedar como texto suelto
									//sin autor (Esteban, 2026-09-11).
									const primeraObservacion : string = editableStudent.id == null
										? String(editableStudent.observations || "").trim()
										: ""
									const registroAGuardar : any = editableStudent.id == null
										? {...editableStudent, observations : ""}
										: editableStudent

									StudentsService.saveStudent(registroAGuardar, userProfile.currentRole == ROLE.SUPER_ADMIN).then
									(
										async (response : any)=>
										{
											//Alumno nuevo: se le suben sus documentos y se le registra la matrícula elegida.
											if(editableStudent.id == null)
											{
												const newId = response && response.data ? response.data.id : null

												if(newId)
												{
													if(primeraObservacion !== "")
													{
														try
														{
															await http.studentService.addStudentNote
																(campusRef[currentUserCampus].id, newId, primeraObservacion)
														}
														catch(noteError)
														{
															console.log(noteError)
															window.alert(Constants.Common.firstNoteFailed)
														}
													}

													for(const documento of documentosNuevos)
													{
														try
														{
															await http.studentService.uploadStudentDocument
															(
																campusRef[currentUserCampus].id, newId, documento.tipo, "", documento.archivo
															)
														}
														catch(uploadError)
														{
															console.log(uploadError)
															window.alert(Constants.Common.newStudentIdUploadFailed)
														}
													}

													/*
														Una matricula por horario elegido, una detras de otra. Si una falla
														se avisa por su nombre y se sigue con las demas: el alumno ya
														quedo creado y perder las otras matriculas por una sola seria peor.
														(Esteban, 2026-09-21)
													*/
													const fallidas : string[] = []

													for(const horario of horariosElegidos)
													{
														try
														{
															const matricula : any = await EnrollmentsService.addEnrollments
															(
																{
																	course_id : horario.courseId,
																	level_id  : horario.levelId,
																	id        : horario.id
																},
																{
																	studentWithKitIds : String(newId),
																	notes             : notaMatricula.trim(),
																	advisors          : (asesoras ?? []).map
																	(
																		(asesora : any) => ({userId : asesora.userId, sharePercentage : asesora.sharePercentage})
																	)
																}
															)

															if(matricula.status != 200 && matricula.status != 204)
															{
																throw new Error(matricula.statusText)
															}
														}
														catch(enrollError)
														{
															console.log(enrollError)
															fallidas.push(cursoCorto(horario.courseName) + " · " + horarioBonito(horario.name))
														}
													}

													if(fallidas.length > 0)
													{
														window.alert(Constants.Common.newStudentEnrollFailed + "\n\n" + fallidas.join("\n"))
													}
												}

												setDocumentosNuevos([])
											}
											setSaveSuccess(true)
											setUIStatus(UIState.SUCCESS)

											setTimeout
											(
												()=>
												{
													closeFn()
													afterCloseFn()
													setSaveSuccess(false)
													setUIStatus(UIState.NORMAL)
													setEditableStudent(null)
												},
												tunning.MODAL_DISMISS_DELAY
											)
										},
										(error : any)=>
										{
											console.log(error)
											setUIStatus(UIState.ERROR)
											dispatch(disableIdleLockSwitch())
											setSaveError(getErrorMessage(error))
										}
									)
								}
							}
						}
					}
				}
			}
		}
	}

	const imageLoad = (event : any)=>
	{
		if(event && event.target && event.target.files && event.target.files.length > 0)
		{
			if(event.target.files[0].size > 5242880 || imageTypes.indexOf(event.target.files[0].type) < 0)
			{
				setSaveError
				(
					<>
						Sólo se permiten imágenes con las siguientes características:
						<br />
						&emsp;Tamaño &lt;= 5MB, &nbsp;Formato : [BMP, GIF, JPEG, PNG, WEBP]
					</>
				)

				setUIStatus(UIState.ERROR)

				if(imageRef != null && imageRef.current != null)
				{
					imageRef.current.value = ""
				}
			}
			else
			{
				let student : any    = {...editableStudent, image : event.target.files[0]}
				fileReader           = new FileReader()
				fileReader.onloadend = (event : any) =>
				{
					setEditableStudent({...student, imagePreview : fileReader.result})

					if(imageRef != null && imageRef.current != null)
					{
						imageRef.current.value = ""
					}
				}

				fileReader.readAsDataURL(event.target.files[0])
			}
		}
	}

	const imageDisposal = ()=>
	{
		if (imageRef != null && imageRef.current != null)
		{
			imageRef.current.value = ""
		}

		setEditableStudent
		({
			...editableStudent, image : null,
			imagePreview              : null,
		})
	}

	const removeContact = (index : number)=>
	{
		var contacts = editableStudent.contacts

		contacts.splice(index, 1)

		setEditableStudent({...editableStudent, contacts : contacts})
	}

	const changeContactData = (index : number, field : string, event : any)=>
	{
		if(event && event.target)
		{
			var contacts = editableStudent.contacts

			contacts.splice(index, 1, {...editableStudent.contacts[index], [field] : event.target.value})
			setEditableStudent({...editableStudent, contacts : contacts})
		}
	}

	const handleRegistryChange = (event : any)=>
	{
		if(event && event.target)
		{
			setEditableStudent({...editableStudent, [event.target.name] : event.target.value})
		}
	}
	//FX---------------------------------------------------------------------------------------------------------------------
	useEffect
	(
		()=>
		{
			trigger
			({
				type    : "setIsButtonDisabled",
				payload : (idleLocked || UIStatus == UIState.SUCCESS)
			})
		},
		[UIStatus, idleLocked]
	)

	useEffect
	(
		()=>
		{
			let cautionDate = new Date(date + " 23:00:00")
			let maximumDate = new Date(cautionDate)

			//Nadie menor de 7 años (Esteban, 2026-09-11)
			maximumDate.setFullYear(maximumDate.getFullYear() -  7)
			cautionDate.setFullYear(cautionDate.getFullYear() - 10)
			setMaxDate(maximumDate)
			setWarningDate(cautionDate)
			setMinDate(new Date(sprintf("%04d-01-01 23:00:00", minYear)))

			if(selectedStudent.id == null)
			{
				setEditableStudent(selectedStudent)
			}

		},
		[]
	)
	//-----------------------------------------------------------------------------------------------------------------------
	return <DataDisplayModal saveSuccess={saveSuccess} wrongValueOnFields={wrongValueOnFields} unchangedRecord={unchangedRecord}
	  form={recordFormRef} headIcon={<CustomIcon name="student" />} dataEditInit={editStudent} unfilledFields={unfilledFields}
	  saveLock={state.isButtonDisabled} promptCloseFn={closeFn} saveDataFn={saveRecord} entityName="Alumno" uneditFn={unedit}
	  allowedUpdate={!selectedStudent.bool_read_only && allowedUpdate} UIStatus={UIStatus} editableRecord={editableStudent}
	  processingError={saveError}
	><div className="container"><div className="row">
		<div className="col-md-4 text-center"><div style={{position : "sticky", top : "0px"}}>
			{/*
				En telefono la foto se comia media pantalla antes de mostrar un solo
				dato del alumno. Se encoge a algo que se reconoce sin estorbar.
				(Esteban, 2026-09-16)
			*/}
			<div style=
			  {{
				maxWidth  : esTelefono ? "104px" : "250px",
				maxHeight : esTelefono ? "104px" : "250px",
				display   : "inline-block"
			  }}
			>
				<img className="relatedPicture" src=
				  {
					(editableStudent == null ? selectedStudent.imagePreview : editableStudent.imagePreview)
						|| avatarPorDefecto
				 }
				/>
				{
					editableStudent == null ? "" : <>
						<input accept="image/*" type="file" style={{display : "none"}} name="image" ref={imageRef}
						  onChange={imageLoad} id="image"
						/>
						{
							editableStudent.image == null ? "" : <button className="btn btn-danger rounded-pill"
							  disabled={idleLocked} type="button" onClick={imageDisposal} style=
							  {{
								position : "relative",
								bottom   : "40px",
								left     : "15%"
							 }}
							>
								<FontAwesomeIcon icon={solid("times")} size="2x" fill="unset" />
							</button>
						}
						<button onClick={() => buttonClickHandling(imageRef)} className="btn rounded-pill" type="button"
						  disabled={idleLocked} style=
						  {{
							position : "relative", background : "var(--wa-gris)", height : "56px", left : "16%",
							bottom   : "40px"    , border     : "1px solid var(--main-bg-color)",
							color    : "var(--secondary-txt-color)",
						 }}
						>
							<FontAwesomeIcon icon={solid("camera")} style={{color : "var(--wa-negro)"}} size="2x" fill="unset" />
						</button>
					</>
				}
			</div>
			<br />
			<br />
			<div className="inputContainer text-start">
				<label htmlFor="identity_code" style={{position : "relative"}}>
					Correlativo
				</label>
				<div className="roView">
					{selectedStudent.student?.identity_code || "-"}
				</div>
			</div>
			{
				(editableStudent == null || editableStudent.id != null) ? "" : <div className="text-start" style={{marginBottom : "12px"}}>
					<div className="card" style={{borderLeft : "4px solid " + (editableIsMinor() ? "var(--wa-rojo)" : "var(--wa-acento)"), padding : "10px 12px"}}>
						<b style={{fontSize : "13px"}}>{Constants.Common.newStudentIdTitle}</b>
						<div style={{fontSize : "12px", color : "var(--wa-apagado)", margin : "4px 0 8px"}}>{Constants.Common.newStudentIdWarning}</div>
						<div style={{fontSize : "12px", color : "var(--wa-rojo)", marginBottom : "6px"}}>
							{editableIsMinor() ? Constants.Common.newStudentIdMinorHint : Constants.Common.newStudentIdAdultHint}
						</div>
						{
							documentosNuevos.length < 1 ? "" : <div style={{marginBottom : "8px"}}>{
								documentosNuevos.map
								(
									(documento : any, indice : number) => <div key={"dn_" + indice} style=
									{{
										display : "flex", alignItems : "center", gap : "6px",
										fontSize : "12px", marginBottom : "4px"
									}}>
										<span className={"badge rounded-pill " + (documento.tipo == 2 ? "bg-success" : "bg-secondary")}>
											{documento.tipo == 2 ? "Tutor" : "Alumno"}
										</span>
										<span style={{flex : "1 1 auto", overflow : "hidden", textOverflow : "ellipsis", whiteSpace : "nowrap"}}>
											{documento.archivo.name}
										</span>
										<button type="button" className="btn btn-sm btn-link" style={{padding : "0px", color : "var(--wa-rojo)"}}
										  disabled={idleLocked}
										  onClick={() => setDocumentosNuevos(documentosNuevos.filter((_ : any, i : number) => i != indice))}
										>
											<FontAwesomeIcon icon={solid("times")} />
										</button>
									</div>
								)
							}</div>
						}
						<select className="form-select form-select-sm" style={{marginBottom : "6px"}} disabled={idleLocked}
						  value={tipoDocumento} onChange={(event : any) => setTipoDocumento(+event.target.value)}
						>
							<option value={1}>Identificación del alumno</option>
							<option value={2}>Identificación del padre o tutor</option>
						</select>
						<input className="form-control form-control-sm" type="file" disabled={idleLocked}
						  accept="image/jpeg,image/png,image/webp,image/heic,image/heif,application/pdf,.heic,.heif"
						  onChange=
						  {
							(event : any)=>
							{
								if(event.target.files && event.target.files.length > 0)
								{
									setDocumentosNuevos([...documentosNuevos, {tipo : tipoDocumento, archivo : event.target.files[0]}])
									event.target.value = ""
								}
							}
						  }
						/>
						<div style={{fontSize : "12px", color : "var(--wa-apagado)", marginTop : "4px"}}>
							{Constants.Common.newStudentIdMultiHint}
						</div>
					</div>
				</div>
			}
			{
				(editableStudent != null || selectedStudent.id == null) ? "" : <div className="text-start" style={{marginBottom : "10px"}}>
					<StudentDocumentsTab
					  studentId={selectedStudent.id}
					  campusId={campusRef[currentUserCampus].id}
					  canUpload={allowedUpdate}
					  compact
					/>
				</div>
			}
			<div className="inputContainer text-start">
				<label htmlFor="correlativo_clase_365">
					Correlativo Classe365
				</label>
				{
					editableStudent == null
							?
						<div className="roView">
							<br />
							{selectedStudent?.correlativo_clase_365 || "-"}
						</div>
							:
						<input onChange={handleRegistryChange} ref={correlativoClase365Ref}
						  onFocus={validateField} placeholder="Correlativo Classe365"
						  onBlur={validateField} style={{width : "100%"}}
						  disabled={idleLocked} value={editableStudent.correlativo_clase_365} name="correlativo_clase_365"
						  id="correlativo_clase_365" maxLength={50} type="text" required
						/>
				}
			</div>
			{
				editableStudent || selectedStudent.campuses== null ? "" : <div style={{textAlign : "left"}}>
					{/*
						Era un fieldset con legend, de estilo viejo, que no se parecia a
						ninguna otra seccion de la aplicacion. Pasa al mismo encabezado
						subrayado que usa el resto de la ficha. (Esteban, 2026-09-16)
					*/}
					<div style={{padding : "0px 15px"}}>
						<UnderlineHeading name={"Saldo mensualidades"} />
						<div className="fluentBox">
							<div className="fluentBlockXs" style={{padding : "0px 5px"}}>
								<b>
									Vencido
								</b>
							</div>
							<div className="text-end fluentBlockXs" style={{padding : "0px 5px", whiteSpace : "nowrap", color : selectedStudent.expiredMonthlyBalance == 0 ? "var(--wa-tinta)" : "var(--wa-rojo)"}}>
								{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
								&nbsp;
								{montoBonito(selectedStudent.expiredMonthlyBalance)}
							</div>
						</div>
						<div className="fluentBox">
							<div className="fluentBlockXs" style={{padding : "0px 5px"}}>
								<b>
									Total
								</b>
							</div>
							<div className="text-end fluentBlockXs" style={{padding : "0px 5px", whiteSpace : "nowrap", color : selectedStudent.monthlyBalance == 0 ? "var(--wa-tinta)" : "var(--wa-rojo)"}}>
								{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
								&nbsp;
								{montoBonito(selectedStudent.monthlyBalance)}
							</div>
						</div>
					</div>
					<div style={{padding : "15px"}}>
						<div className="fluentBox">
							<div className="fluentBlockXs" style={{padding : "0px 5px"}}>
								<b>
									Productos
								</b>
							</div>
							<div className="text-end fluentBlockXs" style={{padding : "0px 5px", flexBasis : "50%", whiteSpace : "nowrap", color : selectedStudent.productsBalance == 0 ? "var(--wa-tinta)" : "var(--wa-rojo)"}}>
								{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
								&nbsp;
								{montoBonito(selectedStudent.productsBalance)}
							</div>
						</div>
						<div className="fluentBox">
							<div className="fluentBlockXs" style={{padding : "0px 5px"}}>
								<b>
									Servicios
								</b>
							</div>
							<div className="text-end fluentBlockXs" style={{padding : "0px 5px", flexBasis : "50%", flexGrow : 1, whiteSpace : "nowrap", color : selectedStudent.servicesBalance == 0 ? "var(--wa-tinta)" : "var(--wa-rojo)"}}>
								{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
								&nbsp;
								{montoBonito(selectedStudent.servicesBalance)}
							</div>
						</div>
						<div className="fluentBox">
							<div className="fluentBlockXs" style={{padding : "0px 5px"}}>
								<b>
									Crédito a favor
								</b>
							</div>
							<div className="text-end fluentBlockXs" style={{padding : "0px 5px", flexBasis : "50%", flexGrow : 1, whiteSpace : "nowrap", color : selectedStudent.positiveBalance == 0 ? "var(--wa-tinta)" : "var(--wa-verde)"}}>
								{basicInfo.currencyRef["C_" + campusRef[currentUserCampus].company.currency_id].symbol}
								&nbsp;
								{montoBonito(selectedStudent.positiveBalance)}
							</div>
						</div>
					</div>
				</div>
			}
			{/* El estatus ya no se muestra ni se edita: todos los alumnos van en Activo (Esteban, 2026-09-24). */}
			{
				cursosAlumno.length < 1 ? "" : <>
					<br />
					<div className="card card-default" style={{padding : "15px"}}>
						<div><label style={{position : "relative"}}><b style={{color : "var(--wa-apagado)"}}>
							Cursos
						</b></label></div>
						<div style={{textAlign : "left", display : "flex", flexFlow : "wrap"}}>{
							cursosAlumno.map
							(
								(curso : any, index : number) => <div key={"cr_" + index}
								  style={{display : "inline-block", padding : "5px", margin : "3px"}}
								  className={"badge rounded-pill prompt " + pildoraDeCurso(curso)}
								>
									{curso.nombre}
								</div>
							)
						}</div>
					</div>
				</>
			}
		</div></div>
		<div className="col-md-8">
			<div ref={tabDivRef} tabIndex={-1} style=
			  {{
				borderBottom : "1px solid var(--main-txt-color)",
				alignItems   : "stretch",
				display      : "flex",
				flexFlow     : "row"
			 }}
			>
				<Popover isOpen={(unfilledMainData || noContactsProvided || wrongContactsProvided) && currentTab != "profile"} positions={["bottom"]} content=
				  {<div style={{background : "var(--main-bg)", padding : "5px 5px 0px 5px"}}>
					<div className="requirementAlert">
						<FontAwesomeIcon icon={solid("exclamation")} />
					</div>
					&nbsp;
					{
						unfilledMainData
							? "Requerido : Aún hay campos por llenar"
							: (noContactsProvided
									? (editableIsMinor() ? Constants.Common.minorContactsRequired : "Requerido: agregue al menos un contacto de emergencia.")
									: "Requerido: Hay campos en los contactos de emergencia sin llenar.")
					}
				  </div>}
				><button onClick={() => setCurrentTab("profile")} disabled={idleLocked || currentTab == "profile"}
				  style={{flex : "1", verticalAlign : "top"}} className="btn btn-default"
				><span style={{display : "block", position : "relative", width : "100%", height : "100%", verticalAlign : "top"}}>
					<FontAwesomeIcon icon={solid("user")} />
					<br />
					<span className="d-inline-block" style={{paddingLeft : "10px"}}>
						{Constants.Common.profileInfo}
					</span>
				</span></button></Popover>
				{
					(editableStudent || selectedStudent.id == null) ? "" : <button onClick={() => setCurrentTab("history")} className="btn btn-default"
					  disabled={idleLocked || currentTab == "history"} style={{flex : "1", verticalAlign : "top"}}
					><span style={{display : "block", position : "relative", width : "100%", height : "100%", verticalAlign : "top"}}>
						<CustomIcon name="enrollments" />
						<br />
						<span className="d-inline-block" style={{paddingLeft : "10px"}}>
							Matrículas
						</span>
					</span></button>
				}
				{
					(editableStudent || selectedStudent.id == null) ? "" : <button onClick={() => setCurrentTab("audit")} className="btn btn-default"
					  disabled={idleLocked || currentTab == "audit"} style={{flex : "1", verticalAlign : "top"}}
					><span style={{display : "block", position : "relative", width : "100%", height : "100%", verticalAlign : "top"}}>
						<FontAwesomeIcon icon={solid("clock-rotate-left")} />
						<br />
						<span className="d-inline-block" style={{paddingLeft : "10px"}}>
							{Constants.Common.profileHistory}
						</span>
					</span></button>
				}
			</div>
			<Tabs
			  className="display-none"
			  defaultActiveKey="profile"
			  activeKey={currentTab!!}
			  onSelect={setCurrentTab}
			  id="studentForm"
			>
				<Tab eventKey="profile" title=""><div className="compactProfile"><form ref={recordFormRef} className="form" onSubmit=
				  {
					(event : FormEvent)=>
					{
						event.preventDefault()
						saveRecord()
					}
				 }
				>
					<br />
					<UnderlineHeading name={"Datos personales"} />
					<div className="row">
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="name">
								{editableStudent == null ? "" : "*"}
								Nombres
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent.first_name}
									</div>
										:
									<input
									  style={{width : "100%"}}
									  onChange={handleRegistryChange}
									  ref={firstNameRef}
									  maxLength={50}
									  placeholder="Nombres"
									  type="text"
									  id="first_name"
									  disabled={idleLocked}
									  value={editableStudent.first_name}
									  name="first_name"
									  onFocus={validateField}
									  onBlur={(event : any) => formatField(event, handleRegistryChange)}
									  required
									/>
							}
						</div></div>
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="name">
								{editableStudent == null ? "" : "*"}
								Apellidos
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent.last_name}
									</div>
										:
									<input
									  value={editableStudent.last_name}
									  onChange={handleRegistryChange}
									  placeholder="Apellidos"
									  style={{width : "100%"}}
									  onFocus={validateField}
									  name="last_name"
									  maxLength={50}
									  type="text"
									  id="last_name"
									  onBlur={(event : any) => formatField(event, handleRegistryChange)}
									  disabled={idleLocked}
									  ref={lastNameRef}
									  required
									/>
							}
						</div></div>
						<div className="col-md-6"><div className="selectContainer">
							<label htmlFor="identification_type_id">
								Tipo de identificación
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{
											(
												(selectedStudent && selectedStudent.identification_type)
													&&
												selectedStudent.identification_type.name
											)
												|| ""
										}
									</div>
										:
									<>
										<select
										  disabled={idleLocked}
										  id="identification_type_id"
										  className="btn btn-primary text-start"
										  value={editableStudent.identification_type_id}
										  name="identification_type_id" style={{height : "30px"}}
										  onChange=
										  {
											(event : any)=>
											{
												setEditableStudent
												({
													...editableStudent, identification_type_id : event.target.value,
													identification_code : !basicInfo
														.identificationTypeRef["IT_" + event.target.value]
														.pattern
														.regexp
														.test(editableStudent.identification_code)
																?
															""
																:
															editableStudent.identification_code
												})
											}
										  }
										>{
											basicInfo.identificationTypes.map
											(
												(record : any, i : any) => <option key={i} value={record.id}>
													{record.name}
												</option>
											)
										}</select>
										<div className="iconRight" style={{pointerEvents : "none"}}>
											<CustomIcon name="rowDown" />
										</div>
									</>
							}
						</div></div>
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="name">
								{editableStudent == null ? "" : "*"}
								Código de identificación
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent.identification_code || "-"}
									</div>
										:
									<input
									  onFocus={validateField}
									  disabled={idleLocked}
									  placeholder="Código"
									  type="text"
									  value={editableStudent.identification_code}
									  name="identification_code"
									  ref={identificationCodeRef}
									  id="identification_code"
									  onBlur={validateField}
									  style={{width : "100%"}}
									  data-description={basicInfo.identificationTypeRef["IT_" + editableStudent.identification_type_id].description}
									  pattern={basicInfo.identificationTypeRef["IT_" + editableStudent.identification_type_id].pattern.value}
									  minLength={basicInfo.identificationTypeRef["IT_" + editableStudent.identification_type_id].min_length}
									  maxLength={basicInfo.identificationTypeRef["IT_" + editableStudent.identification_type_id].max_length}
									  onChange=
									  {
										(event : any)=>
										{
											if
											(
												(
													basicInfo.identificationTypeRef["IT_" + editableStudent.identification_type_id].bool_only_digits > 0
														? /[0-9]*/
															: /[a-zA-Z0-9\-]*/
												)
												.test(event.target.value)
											)
											{
												setEditableStudent({...editableStudent, identification_code : event.target.value})
												validateField(event)
											}
										}
									  }
									  required
									/>
							}
						</div></div>
						<div className="col-md-6"><div className="selectContainer">
							<label htmlFor="name">
								{editableStudent == null ? "" : "*"}
								Fecha de nacimiento
							</label>
							<div className="campoFecha" style={{paddingTop : "18px"}}>{
								editableStudent == null
										?
									(
										(selectedStudent == null || isEmpty(selectedStudent.birthdayValue)) ? "-" : toAscendingDate
											(selectedStudent.birthdayValue)
									)
										:
									<LeDatePicker onBlur={validateField} value={editableStudent.birthdayValue} months={monthRef}
									  name="birthdayValue" id="birthdayValue" maxDate={maxDate} years={yearsToAlmostPresent}
									  onFocus={validateField} disable={idleLocked} minDate={minDate} onChange=
									  {
										(event : any)=>
										{
											if(event.target.value >= warningDate)
											{
												setSaveError("Se intenta registrar una fecha menor a 10 años para el alumno")
												setUIStatus(UIState.WARNING)
											}
											else
											{
												setSaveError(null)
												setUIStatus(UIState.NORMAL)
											}

											setEditableStudent({...editableStudent, birthdayValue : event.target.value})
										}
									  } required
									/>
							}</div>
						</div></div>
						<div className="col-md-6"><div className="selectContainer">
							<label htmlFor="gender_id">
								{editableStudent == null ? "" : "*"}
								Género
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{
											((selectedStudent && selectedStudent.gender) && selectedStudent.gender.name)
											|| "-"
										}
									</div>
										:
									<>
										<select
										  name="gender_id"
										  disabled={idleLocked}
										  className="btn btn-primary text-start"
										  onChange={handleRegistryChange}
										  style={{height : "30px"}}
										  value={editableStudent.gender_id}
										  id="gender_id"
										  onBlur={validateField}
										  onFocus={validateField}
										  required
										>
											<option value="">
												Seleccione...
											</option>
											{
												basicInfo.genders.map
												(
													(record : any, i : any) => <option key={i} value={record.id}>
														{record.name}
													</option>
												)
											}
										</select>
										<div className="iconRight" style={{pointerEvents : "none"}}>
											<CustomIcon name="rowDown" />
										</div>
									</>
							}
						</div></div>
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="name">
								{editableStudent == null ? "" : "*"}
								Teléfono 1
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{formatPhoneDisplay(selectedStudent.phone1, String(basicInfo.countryRef["C_" + campusRef[currentUserCampus]?.company?.country_id]?.international_phone_prefix || "504")) || "-"}
									</div>
										:
									<PhoneField
									  id="phone1"
									  name="phone1"
									  value={editableStudent.phone1}
									  campusCountryId={campusRef[currentUserCampus]?.company?.country_id}
									  disabled={idleLocked}
									  required
									  onChange={(value : string) => setEditableStudent({...editableStudent, phone1 : value})}
									/>
							}
						</div></div>
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="name">
								Teléfono 2
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{formatPhoneDisplay(selectedStudent.phone2, String(basicInfo.countryRef["C_" + campusRef[currentUserCampus]?.company?.country_id]?.international_phone_prefix || "504")) || "-"}
									</div>
										:
									<PhoneField
									  id="phone2"
									  name="phone2"
									  value={editableStudent.phone2}
									  campusCountryId={campusRef[currentUserCampus]?.company?.country_id}
									  disabled={idleLocked}
									  onChange={(value : string) => setEditableStudent({...editableStudent, phone2 : value})}
									/>
							}
						</div></div>
					</div>
					<br />
					<UnderlineHeading name={"Último grado de estudios terminado"} />
					<div className="inputContainer">
						<label htmlFor="academic_degree_id" style={{position : "relative"}}>
							Último grado de estudios terminado
						</label>
						<div className="fluentBox" style={{position : "relative", bottom : "13px"}}><div className="fluentBlock"
						  style={{padding : "0px 5px"}}><div style={{margin : "0px"}} className="selectContainer"
						>
							<br />
							{
								editableStudent == null
									?
								<div className="roView">
									<br />
									{
										(
											(selectedStudent && selectedStudent.academic_degree)
											&& selectedStudent.academic_degree.name
										)
										|| "-"
									}
								</div>
									:
								<>
									<select
									  className="btn btn-primary text-start"
									  value={editableStudent.academic_degree_id}
									  style={{height : "30px"}}
									  name="academic_degree_id"
									  id="academic_degree_id"
									  onChange={handleRegistryChange}
									  disabled={idleLocked}
									  onFocus={validateField}
									  onBlur={validateField}
									>
										<option value="">
											Seleccione...
										</option>
										{
											academicDegrees.map
											(
												(record : any, i : any) => <option key={i} value={record.id}>
													{record.name}
												</option>
											)
										}
									</select>
									<div className="iconRight" style={{pointerEvents : "none"}}>
										<CustomIcon name="rowDown" />
									</div>
								</>
							}
						</div></div></div>
					</div>
					<br />
					{/* "Última escuela" se quitó de la forma: el dato ya guardado se conserva (Esteban, 2026-09-11) */}
					<div className="row">
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="current_occupation">
								{editableStudent == null ? "" : "*"}
								Ocupación actual
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent.current_occupation || "-"}
									</div>
										:
									<input
									  onFocus={validateField}
									  style={{width : "100%"}}
									  placeholder="ocupación actual"
									  disabled={idleLocked}
									  onChange={handleRegistryChange}
									  onBlur={(event : any) => formatField(event, handleRegistryChange)}
									  name="current_occupation"
									  value={editableStudent.current_occupation}
									  ref={currentOccupationRef}
									  type="text"
									  id="current_occupation"
									  required
									/>
							}
						</div></div>
					</div>
					<br />
					<UnderlineHeading name={"Ubicación"} />
					<div className="row">
						<div className="col-md-6">
							<div className="selectContainer"><label htmlFor="nationality_id">
								{editableStudent ? "*" : ""}
								Nacionalidad
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent?.nationality?.name || "-"}
									</div>
										:
									<>
										<select value={editableStudent.nationality_id} ref={nationalitySelRef}
										  onChange={handleRegistryChange} disabled={idleLocked}
										  id="nationality_id" name="nationality_id" className="btn btn-primary text-start"
										  style={{height : "30px"}}
										>{
											basicInfo.countries.filter((country : any) => country.bool_campus_exclusive_use < 1).map
											(
												(record : any, i : any) => <option key={i} value={record.id}>
													{record.name}
												</option>
											)
										}</select>
										<div className="iconRight" style={{pointerEvents : "none"}}>
											<CustomIcon name="rowDown" />
										</div>
									</>
							}
						</div></div>
						<div className="col-md-6">
							<div className="selectContainer">
								<label htmlFor="country_id">
									{editableStudent ? "*" : ""}
									País de residencia
								</label>
								{
									editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent?.country?.name || "-"}
									</div>
										:
									<>
										<select
										  className="btn btn-primary text-start"
										  value={editableStudent.country_id}
										  style={{height : "30px"}}
										  disabled={idleLocked}
										  ref={countrySelRef}
										  name="country_id"
										  id="country_id"
										  onChange=
										  {
											(event : any) => setEditableStudent
											({
												...editableStudent, country_id : event.target.value,
												state_id                        : "",
												state_name                      : "",
												city                            : null,
												city_name                       : ""
											})
										  }
										>{
											basicInfo.countries.filter((country : any) => country.bool_campus_exclusive_use < 1).map
											(
												(country : any, i : any) => <option key={i} value={country.id}>
													{country.name}
												</option>
											)
										}</select>
										<div className="iconRight" style={{pointerEvents : "none"}}>
											<CustomIcon name="rowDown" />
										</div>
									</>
								}
							</div>
						</div>
						<div className="col-md-6">
							<div style={{margin : "unset", width : "100%"}}
							  className=
							  {
								(
									(editableStudent == null && basicInfo.countryRef["C_" + selectedStudent.country_id].states.length < 1)
										||
									(editableStudent && basicInfo.countryRef["C_" + editableStudent.country_id].states.length < 1)
								)
									? "inputContainer"
										: "selectContainer"
							  }
							>
								<label htmlFor="state_id">
									{editableStudent == null ? "" : "*"}
									Estado/Depto./Provincia...
								</label>
								<div className="roView" style={{width : "100%"}}>{
									editableStudent == null
											?
										<>
											<br />
											{
												(
													(selectedStudent && selectedStudent.state)
															?
														selectedStudent.state.name
															:
														selectedStudent.state_name
												)
													|| "-"
											}
										</>
											:
										(
											(
												(editableStudent == null && basicInfo.countryRef["C_" + selectedStudent.country_id].states.length < 1)
													||
												(editableStudent && basicInfo.countryRef["C_" + editableStudent.country_id].states.length < 1)
											)
													?
												<>
													<br />
													<input
													  type="text"
													  maxLength={50}
													  id="state_name"
													  name="state_name"
													  ref={stateNameRef}
													  disabled={idleLocked}
													  onBlur={(event : any) => formatField(event, handleRegistryChange)}
													  onFocus={validateField}
													  style={{position : "relative", width : "100%"}}
													  onChange={handleRegistryChange}
													  value={editableStudent.state_name}
													  required
													/>
												</>
													:
												<>
													<select
													  id="state_id"
													  name="state_id"
													  ref={stateSelRef}
													  disabled={idleLocked}
													  onBlur={validateField}
													  onFocus={validateField}
													  style={{height : "30px"}}
													  className="btn btn-primary text-start"
													  defaultValue={editableStudent.state_id}
													  onChange=
													  {
														(event : any) => setEditableStudent
														({
															...editableStudent, state_id : event.target.value,
															state_name                    : "",
															city                          : null,
															city_name                     : ""
														})
													  }
													  required
													>
														<option value="">
															&emsp;
															Seleccione...
														</option>
														{
															basicInfo.countryRef["C_" + editableStudent.country_id] &&
															basicInfo.countryRef["C_" + editableStudent.country_id].states.map
															(
																(record : any, i : number) => <option
																  value={record.id}
																  key={record.id}
																>
																	{record.name}
																</option>
															)
														}
													</select>
													<div className="iconRight" style={{pointerEvents : "none"}}>
														<CustomIcon name="rowDown" />
													</div>
												</>
										)
								}</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className=
							  {
								(
									(editableStudent == null && basicInfo.countryRef["C_" + selectedStudent.country_id].states.length < 1)
										||
									(editableStudent && basicInfo.countryRef["C_" + editableStudent.country_id].states.length < 1)
								)
									? "inputContainer"
										: "selectContainer"
							  }
							>
								<label htmlFor="city">
									{editableStudent == null ? "" : "*"}
									Ciudad/Municipio/Distrito
								</label>
									<div className="roView" style={{width : "100%", paddingTop : "15px"}}>{
										editableStudent == null
												?
											<div style={{paddingTop : "10px"}}>{
												(
													(
														selectedStudent && selectedStudent.city
															? selectedStudent.city.name
																: selectedStudent.city_name
													) || "-"
												)
											}</div>
												:
											(
												(
													(
														basicInfo.countryRef["C_" + editableStudent.country_id].states.length > 0
															&&
														(editableStudent.state_id == null || basicInfo.countryRef["C_" + editableStudent.country_id].stateRef["S_" + editableStudent.state_id] == null)
													)
														||
													(
														basicInfo.countryRef["C_" + editableStudent.country_id].states.length < 1
															&&
														isEmpty(editableStudent.state_name)
													)
												)
													?
														<div style={{paddingTop : "10px"}}>
															&lt; Proporcione estado &gt;
														</div>
													:
												(
													(
														basicInfo.countryRef["C_" + editableStudent.country_id].states.length < 1
															||
														basicInfo.countryRef["C_" + editableStudent.country_id].stateRef["S_" + editableStudent.state_id].cities.length < 1
													)
															?
														<input
														  type="text"
														  maxLength={50}
														  id="city_name"
														  name="city_name"
														  ref={cityNameRef}
														  disabled={idleLocked}
														  onBlur={(event : any) => formatField(event, handleRegistryChange)}
														  onFocus={validateField}
														  style={{width : "100%"}}
														  onChange={handleRegistryChange}
														  value={editableStudent.city_name}
														  required
														/>
															:
														<Popover
														  positions={["bottom"]}
														  isOpen={noCityProvided}
														  content=
														  {<div style={{background : "var(--main-bg)", padding : "5px 5px 0px 5px"}}>
															<div className="requirementAlert">
																<FontAwesomeIcon icon={solid("exclamation")}/>
															</div>
															&nbsp;
															Requerido: Elija una opción
														  </div>}
														>
															<div style={{width : "100%"}}>
																<SelectReact
																  id="city"
																  name="city"
																  placeholder="Ciudad"
																  disabled={idleLocked}
																  value={editableStudent.city}
																  onChange={handleRegistryChange}
																  children={Object.values(basicInfo.countryRef["C_" + editableStudent.country_id].stateRef["S_" + editableStudent.state_id].cityRef)}
																/>
															</div>
														</Popover>
												)
											)
									}</div>
							</div>
						</div>
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="name">
								{editableStudent == null ? "" : "*"}
								Dirección actual
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent.address || "-"}
									</div>
										:
									<input
									  value={editableStudent.address}
									  onChange={handleRegistryChange}
									  name="address" maxLength={255}
									  placeholder="Dirección actual"
									  style={{width : "100%"}}
									  onFocus={validateField}
									  onBlur={(event : any) => formatField(event, handleRegistryChange)}
									  disabled={idleLocked}
									  pattern="(?=.*\d)\S+(\s+\S+)+"
									  data-description="La dirección debe conformarse por al menos 2 (dos) palabras y contener al menos 1 (un) dígito"
									  type="text"
									  ref={addressRef}
									  id="address"
									  required
									/>
							}
						</div></div>
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="name">
								Código postal
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent.zipcode || "-"}
									</div>
										:
									<input onBlur={validateField} max={999999999} step={1} name="zipcode" type="number"
									  onChange={handleRegistryChange} placeholder="Código postal" min={10000} id="zipcode"
									  value={editableStudent.zipcode} onFocus={validateField} style={{width : "100%"}}
									  ref={zipcodeRef}
									/>
							}
						</div></div>
					</div>
					<div className="row">
						<div className="col-md-6"><div className="inputContainer">
							<label htmlFor="email">
								{editableStudent == null ? "" : "*"}
								Correo electrónico
							</label>
							{
								editableStudent == null
										?
									<div className="roView">
										<br />
										{selectedStudent.email || "-"}
									</div>
										:
									<input onFocus={validateField}
									  maxLength={50}
									  value={editableStudent.email}
									  placeholder="Correo electrónico"
									  type="email"
									  name="email"
									  onBlur={validateField}
									  style={{width : "100%"}}
									  onChange={handleRegistryChange}
									  id="email" autoComplete="off"
									  disabled={idleLocked}
									  ref={emailRef}
									  required
									/>
							}
						</div></div>
						{
							//La contraseña ya no se escribe: se genera sola y se cambia por correo (Esteban, 2026-09-11)
							editableStudent == null ? "" : <div className="col-sm-6"><div className="inputContainer">
								<label htmlFor="password">
									Contraseña
								</label>
								<div style={{paddingTop : "18px"}}>
									{
										editableStudent.id == null
												?
											<div style={{fontSize : "12px", color : "var(--wa-apagado)"}}>
												{Constants.Common.passwordAutoHint}
											</div>
												:
											<>
												<button type="button" className="btn btn-outline-secondary btn-sm rounded-pill"
												  disabled={idleLocked || reinicioEnviado || !editableStudent.email}
												  onClick={reiniciarContrasena}
												>
													<FontAwesomeIcon icon={solid("key")} />
													&nbsp;
													{Constants.Common.resetPassword}
												</button>
												<div style={{fontSize : "12px", color : reinicioEnviado ? "#1E7E34" : "var(--wa-apagado)", marginTop : "4px"}}>
													{reinicioEnviado ? Constants.Common.resetPasswordSent : Constants.Common.resetPasswordHint}
												</div>
											</>
									}
								</div>
							</div></div>
						}
					</div>
					<br />
					{/*
						Las observaciones de un alumno que ya existe se fueron a su propia
						pestana: se guardan solas, sin pasar por el lapiz, pero estaban
						enterradas al fondo de esta forma y nadie lo sabia. Aqui queda solo
						el caso del alta, donde todavia no hay alumno al que colgarlas.
						(Esteban, 2026-09-16)
					*/}
					{selectedStudent.id != null ? null : <>
						<UnderlineHeading name={"Observaciones"} />
						{
							(
									editableStudent == null ? (selectedStudent.observations || "-") : <>
										<textarea
										  id="observations"
										  onChange={handleRegistryChange}
										  onBlur={(event : any) => formatField(event, handleRegistryChange)}
										  value={editableStudent.observations}
										  className="notesField form-control"
										  disabled={idleLocked}
										  ref={observationsRef}
										  name="observations"
										/>
										<div style={{fontSize : "12px", color : "var(--wa-apagado)", marginTop : "4px"}}>
											{Constants.Common.firstNoteHint}
										</div>
									</>
								)
						}
					</>}
					{
						//Un alumno nuevo se matricula en el mismo momento del alta (Esteban, 2026-09-11)
						(editableStudent == null || editableStudent.id != null) ? "" : <>
							<br />
							<UnderlineHeading name={"*Matrícula"} />
							<div style={{fontSize : "12px", color : "var(--wa-apagado)", margin : "4px 0px 8px"}}>
								{Constants.Common.newStudentEnrollHint}
							</div>
							<input
							  className="form-control form-control-sm"
							  style={{marginBottom : "6px"}}
							  placeholder={Constants.Common.searchSchedules}
							  value={busquedaHorario}
							  disabled={idleLocked}
							  onChange={(event : any) => setBusquedaHorario(event.target.value)}
							/>
							{
								horarios == null
										?
									<div className="loader" />
										:
									(
										horariosVisibles.length < 1
												?
											<div style={{padding : "10px", color : "var(--wa-apagado)", fontSize : "13px"}}>
												{Constants.Common.noAvailableSchedules}
											</div>
												:
											<div className="waAltaLista">
												<table className="waAltaTabla">
													<tbody>{
														horariosVisibles.map
														(
															(horario : any) =>
															{
																const elegido : boolean = horariosElegidos.some((x) => x.id === horario.id)

																return <tr key={"nh_" + horario.id}
																  className={elegido ? "elegido" : undefined}
																  onClick={() => alternarHorario(horario)}
																>
																	<td className="waAltaCasilla">
																		<input type="checkbox" disabled={idleLocked}
																		  checked={elegido}
																		  onChange={() => alternarHorario(horario)}
																		/>
																	</td>
																	<td className="waAltaCurso">
																		{cursoCorto(horario.courseName)}
																		<span className="waAltaModulo">
																			{horario.levelName}
																		</span>
																	</td>
																	{/*
																		Solo el nombre del horario, con los dias y las horas en am/pm.
																		Las horas de sesion crudas ("Lu 11:00-15:00, Ma 11:00-15:00...")
																		ocupaban cuatro renglones y decian lo mismo.
																		(Esteban, 2026-09-21)
																	*/}
																	<td className="waAltaHorario">
																		{horarioBonito(horario.name)}
																	</td>
																	<td className="waAltaPeriodo">
																		{horario.periodName}
																	</td>
																	<td className="waAltaFecha">
																		{formatLocalDateTime(horario.startDate)}
																	</td>
																	<td className="waAltaCupo" style={{color : horario.isFull ? "var(--wa-rojo)" : undefined}}>
																		{horario.enrolledStudents}/{horario.studentsLimit}
																	</td>
																</tr>
															}
														)
													}</tbody>
												</table>
											</div>
									)
							}
							{
								/*
									Se confirma la lista antes de guardar: cada matricula genera su
									inscripcion y sus mensualidades, y deshacerlas cuesta.
									(Esteban, 2026-09-21)
								*/
								horariosElegidos.length < 1 ? null : <div className="waAltaConfirmar">
									<span className="waAltaConfirmarTitulo">
										{
											horariosElegidos.length === 1
												? "Se va a matricular en 1 horario:"
												: "Se va a matricular en " + horariosElegidos.length + " horarios:"
										}
									</span>
									<ul>{
										horariosElegidos.map((horario) => <li key={"cf_" + horario.id}>
											{cursoCorto(horario.courseName)} · {horarioBonito(horario.name)} · {horario.periodName}
										</li>)
									}</ul>
									<label className="waAltaConfirmarCasilla">
										<input type="checkbox" disabled={idleLocked}
										  checked={matriculasConfirmadas}
										  onChange={(evento : any) => setMatriculasConfirmadas(evento.target.checked)}
										/>
										<span>
											Confirmo estas matrículas
										</span>
									</label>
								</div>
							}
							<div className="row" style={{marginTop : "10px"}}>
								<div className="col-md-6">
									<AdvisorsPicker
									  campusId={campusRef[currentUserCampus].id}
									  value={asesoras}
									  onChange={setAsesoras}
									  disabled={idleLocked}
									/>
								</div>
								<div className="col-md-6">
									<label htmlFor="notaMatricula" style={{position : "relative", display : "block"}}>
										{Constants.Common.signupNote}
										&nbsp;
										<span style={{color : "var(--wa-rojo)"}}>*</span>
									</label>
									<textarea
									  id="notaMatricula"
									  className="form-control"
									  style={{minHeight : "90px"}}
									  maxLength={2000}
									  disabled={idleLocked}
									  placeholder={Constants.Common.signupNotePlaceholder}
									  value={notaMatricula}
									  onChange={(event : any) => setNotaMatricula(event.target.value)}
									/>
								</div>
							</div>
						</>
					}
				</form>
				<form ref={contactFormRef} className="form">
					{/*
						Solo mirando la ficha, las redes sociales vacias ocupaban tres
						renglones diciendo "-" cada una. Cuando no hay ninguna, la seccion
						entera no se dibuja; cuando hay alguna, salen solo las que tienen
						algo. Al editar salen todas, porque ahi si hay que poder llenarlas.
						(Esteban, 2026-09-16)
					*/}
					{
						(editableStudent == null && !Object.keys(linkInfo).some(llave => !isEmpty(selectedStudent[llave])))
							? null
							: <>
								<div style={{width : "inherit", display : "inline-block", position : "sticky", left : "0px", paddingTop : "15px"}}>
									<UnderlineHeading name={"Perfiles Redes Sociales"} />
								</div>
								<div className="row">{
									Object.keys(linkInfo)
										.filter(record => editableStudent != null || !isEmpty(selectedStudent[record]))
										.map
										(
											(record : any) => <div className="col-md-6" key={record}><div className="inputContainer"
											>
												<label htmlFor={record}>
													{linkInfo[record]}
												</label>
												{
													editableStudent == null
															?
														<div className="roView">
															<br />
															{selectedStudent[record]}
														</div>
															:
														<input id={record} style={{width : "100%"}} value={editableStudent[record] || ""}
														  onChange={handleRegistryChange} name={record} type="text"
														  disabled={idleLocked} placeholder={linkInfo[record]} maxLength={50}
														/>
												}
											</div></div>
										)
								}</div>
							</>
					}
					<div style={{width : "inherit", display : "inline-block", position : "sticky", left : "0px"}}>
						<br />
						<div>
							<UnderlineHeading name={((editableStudent != null && editableIsMinor()) ? "*" : "") + "Contactos de emergencia"} />
						</div>
					</div>
					<div className="fluentBox">{
						editableStudent != null ? editableStudent.contacts.map
						(
							(contact : any, index : number) => <div className="fluentBlock" key={"sC_" + index}
							  style={{borderRadius : "15px", background : "#E7E7E7", margin : "15px"}}
							>
								<div style={{padding : "0px 15px"}}><div className="inputContainer">
									<label>
										*Nombres
									</label>
									<input style={{background : "var(--main-bg)"}} placeholder="nombres" maxLength={50}
									  onChange={(event : any) => changeContactData(index, "name", event)} type="text"
									  disabled={idleLocked} onBlur={validateField}
									  onFocus={validateField} value={contact.name}
									  id={"contacts[" + index + "].name"} name={"contacts[" + index + "].name"}
									  required
									/>
								</div></div>
								<div style={{padding : "0px 15px"}}><div className="inputContainer">
									<label>
										*Relación/Parentesco
									</label>
									<input onChange={(event : any) => changeContactData(index, "relation", event)}
									  style={{background : "var(--main-bg)"}} name={"contacts[" + index + "].relation"}
									  onBlur={validateField} value={contact.relation}
									  onFocus={validateField} disabled={idleLocked}
									  id={"contacts[" + index + "].relation"} placeholder="parentesco, amistad..."
									  type="text" maxLength={50} required
									/>
								</div></div>
								<div style={{padding : "0px 15px"}}><div className="inputContainer">
									<label style={{position : "relative"}}>
										*Información para contactar
									</label>
									<textarea style={{height : "50px", resize : "none", background : "var(--main-bg)"}}
									  onFocus={validateField} disabled={idleLocked}
									  onBlur={validateField} className="form-control"
									  name={"contacts[" + index + "].contactMedia"} placeholder="teléfonos, emails"
									  onChange={(event : any) => changeContactData(index, "contactMedia", event)}
									  id={"contacts[" + index + "].contactMedia"} value={contact.contactMedia}
									  minLength={8} required
									></textarea>
								</div></div>
								<div className="text-end" style={{padding : "25px 5px 0px"}}><button type="button"
								  className="btn btn-outline-danger rounded-pill" onClick={() => removeContact(index)}
								  disabled={idleLocked}
								>
									<FontAwesomeIcon icon={solid("trash")}/>
								</button></div>
							</div>
						)
							:
						(
							selectedStudent.contacts.length < 1 ? "(ninguno)" : selectedStudent.contacts.map
							(
								(contact : any, index : number) => <div key={"sC_" + index} className="fluentBlock"
								  style={{borderRadius : "15px", background : "#E7E7E7", margin : "15px"}}
								>
									<div style={{padding : "0px 15px"}}><div className="inputContainer">
										<label>
											Nombres
										</label>
										<br />
										{contact.name}
									</div></div>
									<div style={{padding : "0px 15px"}}><div className="inputContainer">
										<label>
											Relación/Parentesco
										</label>
										<br />
										{contact.relation}
									</div></div>
									<div style={{padding : "0px 15px"}}><div className="inputContainer">
										<label style={{position : "relative"}}>
											*Información para contactar
										</label>
										<br />
										{contact.contactMedia}
									</div></div>
								</div>
							)
						)
					}</div>
					<br />
					{
						editableStudent == null ? "" : <div style={{width : "100%", position : "sticky", left : "0px"}}>
						<Popover positions={["bottom"]} isOpen={noContactsProvided && currentTab == "profile"} content=
						  {<div style={{background : "var(--main-bg)", padding : "5px 5px 0px 5px"}}>
							<div className="requirementAlert">
								<FontAwesomeIcon icon={solid("exclamation")} />
							</div>
							&nbsp;
								{editableIsMinor() ? Constants.Common.minorContactsRequired : "Requerido: agregue al menos un contacto de emergencia."}
						  </div>}
						><button className="btn btn-outline-success" disabled={idleLocked} style={{width : "100%"}}
						  type="button" onClick=
						  {
							()=>
							{
								setEditableStudent
								({
									...editableStudent, contacts:
									[
										...editableStudent.contacts,
										{
											name     : "",
											relation : ""
										}
									]
								})
							}
						 }
						>
							<FontAwesomeIcon icon={solid("plus")} />
							<span style={{padding : "10px"}}>
								Agregar contacto
							</span>
							<FontAwesomeIcon icon={solid("users")} />
						</button></Popover></div>
					}
				</form>
					{
						/*
							Las observaciones vuelven a la misma pantalla que el resto del perfil.
							Tuvieron pestana propia unos dias y no era lo pedido: se lee todo de
							corrido, sin ir a buscarlas a otro lado. Siguen guardandose solas, sin
							tocar el lapiz. (Esteban, 2026-09-20)
						*/
						selectedStudent.id == null ? null : <div style={{padding : "18px 0px 0px"}}>
							<UnderlineHeading name={"Observaciones"} />
							<StudentNotes
							  studentId={selectedStudent.id}
							  campusId={campusRef[currentUserCampus].id}
							  canWrite={(allowedUpdate && !selectedStudent.bool_read_only) || (puedeObservar && selectedStudent.id !== userProfile.id)}
							/>
						</div>
					}
				</div></Tab>
				<Tab eventKey="history" title="">{
					(selectedStudent.id == null || currentTab != "history") ? "" : <StudentHistoryTab
					  studentId={selectedStudent.id}
					  studentName={(selectedStudent.first_name || "") + " " + (selectedStudent.last_name || "")}
					  campusId={campusRef[currentUserCampus].id}
					  studentIdentityCode={selectedStudent.student?.identity_code || ""}
					  canEnroll={allowedUpdate}
					  onEnrolled={afterCloseFn}
					/>
				}</Tab>
				<Tab eventKey="audit" title="">{
					(selectedStudent.id == null || currentTab != "audit") ? "" : <StudentAuditLogTab
					  studentId={selectedStudent.id}
					  campusId={campusRef[currentUserCampus].id}
					/>
				}</Tab>
			</Tabs>
		</div>
	</div></div></DataDisplayModal>
}

export default StudentInfoModal
